import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PLAYER_NAV_ITEMS } from '../config/playerNav';
import { t } from '../locales';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = PLAYER_NAV_ITEMS;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden pointer-events-none"
      aria-label={t('nav.ariaMain')}
    >
      <div
        className="bottom-nav-shell pointer-events-auto"
        style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom, 0px))' }}
      >
        <div className="flex items-stretch justify-between gap-0.5 px-1 pt-2 pb-1 max-w-lg mx-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive =
              item.path === '/profile'
                ? location.pathname === '/profile' || location.pathname.startsWith('/profile/')
                : location.pathname === item.path;
            const isCode = item.path === '/activate';

            return (
              <button
                key={item.path}
                type="button"
                data-testid={item.testId}
                aria-current={isActive ? 'page' : undefined}
                onClick={() => navigate(item.path)}
                className={[
                  'flex flex-1 min-w-0 flex-col items-center justify-end gap-0.5 rounded-xl py-1.5 px-0.5',
                  'transition-all duration-200 ease-out motion-reduce:transition-none touch-manipulation select-none',
                  'focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/50 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0c]',
                  isActive
                    ? '-translate-y-0.5 motion-reduce:translate-y-0 text-violet-100'
                    : 'translate-y-0 text-zinc-500 active:text-zinc-400',
                  // Kod öğesi pasifken kalıcı dolgu/halka YOK — "sürekli aktif" izlenimi vermesin.
                  // Vurgu yalnız mor ikon tonuyla (aşağıda) yapılır.
                  isCode && isActive
                    ? 'bottom-nav-code-halo-active bg-violet-950/45 ring-1 ring-amber-500/30'
                    : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <span
                  className={[
                    'flex items-center justify-center rounded-lg transition-transform duration-200 ease-out motion-reduce:transform-none',
                    isActive ? 'scale-105 motion-reduce:scale-100' : 'scale-100',
                    isCode ? 'p-0.5' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                >
                  <Icon
                    className={[
                      'shrink-0 transition-[filter,color] duration-200 ease-out',
                      isCode ? 'w-[22px] h-[22px]' : 'w-5 h-5 sm:w-[22px] sm:h-[22px]',
                      isActive
                        ? isCode
                          ? 'text-violet-200 drop-shadow-[0_0_10px_rgba(167,139,250,0.45)]'
                          : 'text-violet-200 drop-shadow-[0_0_8px_rgba(167,139,250,0.35)]'
                        : isCode
                          ? 'text-violet-300/90'
                          : 'text-zinc-500',
                    ].join(' ')}
                    strokeWidth={isActive ? 2.25 : 2}
                    aria-hidden
                  />
                </span>
                <span
                  className={[
                    'w-full text-center text-[10px] sm:text-[11px] font-semibold leading-tight tracking-tight truncate px-0.5',
                    isActive ? 'text-violet-100/95' : 'text-zinc-500',
                  ].join(' ')}
                >
                  {t(item.labelKey)}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
